import { Box, Container, Heading, Text } from '@chakra-ui/react';
import { Eyebrow } from './Section';
interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
}
export function PageHeader({
  eyebrow,
  title,
  subtitle
}: PageHeaderProps) {
  return <Box bg="navy.900" color="white" pt={{
    base: 16,
    md: 24
  }} pb={{
    base: 14,
    md: 20
  }} borderBottom="1px solid" borderColor="whiteAlpha.100" data-id="element-137" data-mp="3rduauotgkb91">
      <Container maxW="1200px" px={{
      base: 6,
      md: 8
    }} data-id="element-138" data-mp="2yqga0fmn2vjn">
        <Box maxW="820px" data-id="element-139" data-mp="2trdgnsg0udri">
          {eyebrow ? <Eyebrow tone="light" data-id="element-140" data-mp="2tsevm805rkei">{eyebrow}</Eyebrow> : null}
          <Heading as="h1" color="white" fontSize={{
          base: '3xl',
          md: '5xl'
        }} lineHeight={1.15} fontWeight={600} data-id="element-141" data-mp="38g9p3qlzpssn">
            {title}
          </Heading>
          {subtitle ? <Text mt={6} fontSize={{
          base: 'md',
          md: 'lg'
        }} color="navy.200" fontWeight={300} maxW="720px" data-id="element-142" data-mp="2fxm9urtod7zh">
              {subtitle}
            </Text> : null}
        </Box>
      </Container>
    </Box>;
}